import { connect } from 'react-redux';
import { Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

// TODO:
// move out Switch to RouterOutlet and think how get rid of pathnames.
// Hint - an appointment has already been booked at this point.
export const RouteRender = ({
  isBookingCompleted = false,
  bookingId,
  location: { pathname },
  children,
}) =>
  isBookingCompleted &&
  !pathname.startsWith('/bookings') &&
  pathname !== '/completed-booking' &&
  !bookingId ? (
    <Redirect push to="/completed-booking" />
  ) : (
    <Switch>{children}</Switch>
  );

export const mapStateToProps = ({
  bookings: { isBookingCompleted, booking },
  router: { location },
}) => ({
  isBookingCompleted,
  location,
  bookingId: booking?.id || null,
});
export const ConnectedRouteRender = connect(mapStateToProps)(RouteRender);

RouteRender.propTypes = {
  isBookingCompleted: PropTypes.bool,
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({}).isRequired,
};
